<template>
  <div class="flex flex-col h-full">
    <global-header :titleVisible="titleVisible" :pageTitle="this.pageHeaderTitle" />
    <div class="flex h-full overflow-hidden relative">
      <router-view @showTitleOnHeader="setHeaderTitle" />
    </div>
  </div>
</template>
<script>
import GlobalHeader from '@/components/GlobalHeader.vue'
export default {
  name: 'PrivateHome',
  components: {
    GlobalHeader
  },
  data: function () {
    return {
      titleVisible: false,
      pageHeaderTitle: ''
    }
  },
  computed: {
    user: function () {
      return this.$store.getters['auth/user']
    }
  },
  created: async function () {
    try {
      this.$store.commit('app/setLoading', true)
      await this.$store.dispatch('auth/downloadUserInfo')
    } catch (error) {
      this.doFeedback()
    } finally {
      this.$store.commit('app/setLoading', false)
    }
  },
  beforeRouteUpdate: function (to, from, next) {
    this.pageHeaderTitle = ''
    next()
  },
  methods: {
    setHeaderTitle: function (val, title) {
      this.titleVisible = val
      this.pageHeaderTitle = title
    }
  }
}
</script>
<style lang="scss" scoped></style>
